import { Typography } from '@euler/app/components/typography';
import { useOrderFlowContext } from '@euler/app/flows/order/OrderFlowContext';
import { FacadeScreenEvent } from '@euler/app/flows/order/types';
import { StatusColors } from '@euler/components/Colors';
import { Icon } from '@euler/components/Icomoon';
import { HStack } from '@euler/components/layout/Stack';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { useCreation } from '@euler/utils/hooks';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { useEffect } from 'react';
import { Platform, ScrollView } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { BehaviorSubject, Subject } from 'rxjs';
import { FacadeInspectionContextProvider } from './components/FacadeInspectionContext';
import { WiredFacadeSitesView } from './components/FacadeSitesView';
import { WiredSiteInspectionResults } from './components/SiteInspectionResultsView';

export const FacadeInspectionScreen = wrapNavigatorScreen(
  () => {
    const insets = useSafeAreaInsets();
    const { rpx } = useResponsiveContext();
    const {
      capabilities,
      formController: { form },
    } = useOrderFlowContext();

    const navigation = useNavigation<StackNavigationProp<any>>();
    const event$ = useCreation(() => new Subject<FacadeScreenEvent>(), []);
    const interacted$ = useCreation(
      () => new BehaviorSubject<boolean>(false),
      [],
    );

    useEffect(() => {
      return navigation.addListener('beforeRemove', () => {
        if (interacted$.value) {
          form.facadeInspectionResults.validate();
        }
      });
    }, [form.facadeInspectionResults, interacted$.value, navigation]);

    return (
      <FacadeInspectionContextProvider interacted$={interacted$}>
        <ScrollView
          showsVerticalScrollIndicator={Platform.OS === 'web'}
          contentContainerStyle={{
            paddingTop: 10,
            paddingBottom: insets.bottom + rpx(10),
          }}
        >
          {capabilities?.preInspectionReadonly ? (
            <HStack
              justifyContent="center"
              css={`
                padding: ${rpx(10)}px;
                margin-bottom: ${rpx(10)}px;
                background-color: #ffdead;
              `}
            >
              <Icon
                name="information-solid"
                color={StatusColors.Warn}
                size={rpx(14)}
              />
              <Typography.Label
                medium
                size={rpx(14)}
                lineHeight={rpx(19)}
                css={`
                  margin-left: ${rpx(5)}px;
                `}
                color={StatusColors.Warn}
              >
                预检已完成，如果要修改预检结果，请前往预检页面。
              </Typography.Label>
            </HStack>
          ) : null}
          <WiredFacadeSitesView event$={event$} />
          <WiredSiteInspectionResults event$={event$} />
        </ScrollView>
      </FacadeInspectionContextProvider>
    );
  },
  {
    title: '外观/物品记录',
  },
);
